import { call, put, select, takeEvery } from 'redux-saga/effects';

import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../../../actions/static-catalogs/insurance-companies';
import * as authSelectors from '../../../reducers/auth';
import * as schemas from '../../../schemas/insurance-companies';
import * as types from '../../../types/static-catalogs/insurance-companies';
import API_BASE_URL from '../../settings/apibaseurl';
/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchInsuranceCompaniesList(action) {
  const country = action.payload;
  try {
    const isAuth = yield select(authSelectors.isAuthenticated);
    if (isAuth && (country || country === 0)) {
      const token = yield select(authSelectors.getAuthToken);
      const response = yield call(fetch, `${API_BASE_URL}/insuranceCompany/get`, {
        method: 'POST',
        body: JSON.stringify({ country }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      });
      const jsonResult = yield response.json();
      if (response.status <= 300 && jsonResult.success) {
        const resultData = jsonResult.data.map((result) => camelcaseKeys(result));
        const {
          entities: { insuranceCompanies },
          result //order
        } = normalize(resultData, schemas.insuranceCompanies); //normalize data to byId and order
        yield put(actions.completeFetchingInsuranceCompanies(insuranceCompanies, result));
      } else {
        const error = {
          errorMessage: jsonResult.message,
          errorNumber: jsonResult.number
        };
        // alerts.showErrorAlertFailChanges({ error });
        yield put(actions.failFetchingInsuranceCompanies(error));
      }
    }
  } catch (err) {
    const error = {
      errorMessage: err.toString(),
      errorNumber: -1
    };
    // alerts.showErrorAlertFailChanges({ error });
    yield put(actions.failFetchingInsuranceCompanies(error));
  }
}

export function* watchFetchInsuranceCompaniesList() {
  yield takeEvery(types.INSURANCE_COMPANIES_FETCH_STARTED, fetchInsuranceCompaniesList);
}
